import React, { createContext } from "react";
export const DataProviderContext = createContext(null);
export function DataProviderProvider({ provider, children, }) {
    return React.createElement(DataProviderContext.Provider, { value: provider }, children);
}
